import { render, staticRenderFns } from "./MasterAccountRestriction.vue?vue&type=template&id=88a4cc2c&scoped=true"
import script from "./MasterAccountRestriction.vue?vue&type=script&lang=js"
export * from "./MasterAccountRestriction.vue?vue&type=script&lang=js"
import style0 from "./MasterAccountRestriction.vue?vue&type=style&index=0&id=88a4cc2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a4cc2c",
  null
  
)

export default component.exports